import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TenantTaskApi } from '../api/tenanttask.api';
import { switchMap, map } from 'rxjs/operators';
import { TenantTask,TenantTaskData } from '../../../interfaces/masters/tenanttask';

@Injectable()
export class TenantTaskService extends TenantTaskData {

  constructor(private api: TenantTaskApi) {
    super();
  }


  list(url: string): Observable<TenantTask[]> {
    return this.api.list(url);
  }



  create(url: string, data: TenantTask[]): Observable<TenantTask> {
    return this.api.add(url,data);
  }

  update(url: string, data: TenantTask): Observable<TenantTask> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
